<img
  alt="error.svg"
  class="mx-auto"
  src="assets/core/error.svg"
/>

<div class="portal-subheading">Application unsuccessful</div>

<p>
  We’re sorry that we are unable to proceed with your CIMB FlexiPay Loan Application. We would love to have you back should you require our
  CIMB Business Loan services in the future.
</p>
